import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import { formatMoney, startingPrice } from '../../utils/pricing';

/**
 * Brushed-titanium banner attached beneath the holographic banner.
 * Matches the holographic banner's height and type scale; always one line.
 */
export function WarrantyBanner({
  className = ''
}: {
  className?: string;
}) {
  const {
    lang
  } = useLanguage();
  const es = lang === 'es';
  const from = formatMoney(startingPrice(), lang);
  const full = es ? ['Garantía de por vida en sistemas de 4+ luces', '1 año en 1 y 2 luces', `Desde ${from}`] : ['Lifetime Warranty on 4+ light systems', '1-Year on 1 & 2 lights', `Starting at ${from}`];
  const medium = es ? ['Garantía de por vida en 4+ luces', `Desde ${from}`] : ['Lifetime Warranty on 4+ lights', `Starting at ${from}`];
  const short = es ? ['De por vida en 4+', `Desde ${from}`] : ['Lifetime on 4+', `From ${from}`];
  const line = (pair: string[], cls: string) => <span className={`items-center justify-center gap-x-4 ${cls}`} data-id="element-1011" data-mp="b9dsgsjo5fal">
      {pair.map((part, i) => <React.Fragment key={part} data-id="element-1012" data-mp="6aajwy4hcqxv" data-mpi={i}>
          {i > 0 && <span aria-hidden className="text-[#248DFF]" data-id="element-1013" data-mp="ky5eyl5yn7e4">
              ◆
            </span>}
          <span data-id="element-1014" data-mp="g7p2b39yrpst">{part}</span>
        </React.Fragment>)}
    </span>;
  return <Link to="/warranty" aria-label={full.join('. ')} className={`mf-titanium relative block w-full overflow-hidden border-b border-[#7E8C99] px-4 py-3 text-center text-[#0B2037] focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-4 focus-visible:outline-marine md:py-3.5 ${className}`} data-id="element-1015" data-mp="tytszfvct7r0">
      <span className="mf-holo-sheen" aria-hidden data-id="element-1016" data-mp="yxn5b4ywmspl" />
      <span className="relative block whitespace-nowrap font-display text-[15px] font-bold uppercase tracking-[0.14em] sm:text-[17px] lg:text-[19px]" aria-hidden data-id="element-1017" data-mp="yw3qzjwt6rqg">
        {line(short, 'flex sm:hidden')}
        {line(medium, 'hidden sm:flex xl:hidden')}
        {line(full, 'hidden xl:flex')}
      </span>
    </Link>;
}